import { type ForwardedRef, forwardRef } from 'react';
import { EmployeeIdpStatus } from '@/common/graphql';
import { EmployeeIdpStatusLabels } from '@/common/types';
import { EmployeeIdpStatusBadge } from '../../badge';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface EmployeeIdpStatusSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<EmployeeIdpStatus>>, 'searchable' | 'value'> {
  value: EmployeeIdpStatus | null;
}

interface EmployeeIdpStatusSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeIdpStatus>>, 'searchable' | 'value'> {
  value: Array<EmployeeIdpStatus> | null | undefined;
}

const data = [
  EmployeeIdpStatus.Draft,
  EmployeeIdpStatus.Reviewing,
  EmployeeIdpStatus.OverdueReviewing,
  EmployeeIdpStatus.OverdueResult,
  EmployeeIdpStatus.CompletedSuccess,
  EmployeeIdpStatus.CompletedFailure,
  EmployeeIdpStatus.Cancelled,
].map(
  value =>
    ({
      value,
      label: EmployeeIdpStatusLabels[value],
      labelFormatted: <EmployeeIdpStatusBadge status={value} />,
    }) as ComboboxItemWithFormatted<EmployeeIdpStatus>,
);

export const EmployeeIdpStatusSelectSingle = forwardRef(
  (
    { placeholder = 'Select IDP status', ...rest }: EmployeeIdpStatusSelectSingleProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => (
    <SelectSingle
      ref={ref}
      {...rest}
      data={data}
      loading={false}
      maxItemVisible={8}
      placeholder={placeholder}
      searchable={false}
    />
  ),
);

export const EmployeeIdpStatusSelectMultiple = ({ ...rest }: EmployeeIdpStatusSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    maxItemVisible={8}
    multipleSelectedLabel={length => `${length} statuses`}
    placeholder={rest.placeholder}
    searchable={false}
  />
);
